export default [
  {
    dataIndex:'rawName',
    fixed: 'left',
    // title: '名称',
    scopedSlots: {customRender: 'rawName'},
    slots: { title: 'customTitle' },
    sorter: (a, b) => a.rawName.localeCompare(b.rawName,'zh'),
    width: 160,
    ellipsis: true,
  },
  {
    dataIndex:'rawCode',
    title: '代码',
    sorter: (a, b) => a.rawCode - b.rawCode,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width: 100
  },
  {
    dataIndex:'price',
    scopedSlots: {customRender: 'price'},
    align:'center',
    title: '价格',
    sorter: (a, b) => a.price - b.price,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:100
  },
  {
    dataIndex:'weight',
    align:'center',
    title: '重量',
    scopedSlots: {customRender: 'weight'},
    sorter: (a, b) => a.mixPercentage - b.mixPercentage,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:100
  },
  {
    dataIndex:'mixPercentage',
    align:'center',
    title: '用量(%)',
    scopedSlots: {customRender: 'mixPercentage'},
    sorter: (a, b) => a.mixPercentage - b.mixPercentage,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:100
  },
  {
    dataIndex:'percentage',
    align:'center',
    title: '按补充料(%)',
    scopedSlots: {customRender: 'percentage'},
    sorter: (a, b) => a.percentage - b.percentage,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:100
  },
  {
    dataIndex:'productRawPercentage',
    align:'center',
    title: '产品(%)',
    scopedSlots: {customRender: 'productRawPercentage'},
    sorter: (a, b) => a.productRawPercentage - b.productRawPercentage,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:100
  },
  {
    dataIndex:'uasge',
    align:'center',
    title: '实际重量',
    scopedSlots: {customRender: 'uasge'},
    sorter: (a, b) => a.uasge - b.uasge,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:100
  },
  {
    dataIndex:'minValue',
    scopedSlots: {customRender: 'minValue'},
    align:'center',
    title: '最小值',
    sorter: (a, b) => a.minValue - b.minValue,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:100
  },
  {
    dataIndex:'maxValue',
    scopedSlots: {customRender: 'maxValue'},
    align:'center',
    title: '最大值',
    sorter: (a, b) => a.maxValue - b.maxValue,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:100
  },
  {
    dataIndex:'cost',
    align:'center',
    title:'单位成本',
    scopedSlots: {customRender: 'cost'},
    sorter: (a, b) => a.cost - b.cost,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:90
  },
  // {
  //   dataIndex:'uasge',
  //   title:'用量(批次量)',
  //   scopedSlots: {customRender: 'uasge'},
  //   width:this.layout.layoutType ? 100 : 130,
          // ellipsis: true,
  //   align:'center'
  // },
  {
    dataIndex:'minShadowPrice',
    align:'center',
    title:'影子价格下限',
    scopedSlots: {customRender: 'minShadowPrice'},
    sorter: (a, b) => a.minShadowPrice - b.minShadowPrice,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:120
  },
  {
    dataIndex:'maxShadowPrice',
    align:'center',
    title:'影子价格上限',
    scopedSlots: {customRender: 'maxShadowPrice'},
    sorter: (a, b) => a.maxShadowPrice - b.maxShadowPrice,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:120
  },
 
  {
    dataIndex:'minApply',
    align:'center',
    title:'适用下限',
    scopedSlots: {customRender: 'minApply'},
    sorter: (a, b) => a.minApply - b.minApply,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:100
  },
  {
    dataIndex:'maxApply',
    align:'center',
    title:'适用上限',
    scopedSlots: {customRender: 'maxApply'},
    sorter: (a, b) => a.maxApply - b.maxApply,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:100
  },
  {
    dataIndex:'minLimitValue',
    scopedSlots: {customRender: 'minLimitValue'},
    align:'center',
    title: '极下限',
    sorter: (a, b) => a.minLimitValue - b.minLimitValue,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:100
  },
   {
    dataIndex:'maxLimitValue',
    scopedSlots: {customRender: 'maxLimitValue'},
    align:'center',
    title:'极上限',
    sorter: (a, b) => a.maxLimitValue - b.maxLimitValue,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:100
  },
]